import React from "react";
import soft_dev_pic_ourspecialisation from "../../Images/software_development.gif";
import servilancecam_our_specialisation from "../../Images/survilance_cam_specialisatoin.gif";
import networking_our_specialisation from "../../Images/networking_specialisation_section.gif";
import ReactTyped from "react-typed";
import camimg from "../../Images/ourWork/cameraimage.gif";
import comserimg from "../../Images/ourWork/compserimage.gif";
import card3Image from "../../Images/GIF/OSFi.gif";
// import { useState } from "react";
// import Popupspecialisation from "../../Popups/Popupspecialisation";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import fullstylecss from "../../../index.css";


import AdvProduct1 from "../../Images/PRODUCTS_IMG/ADVDIARY/PROD_E1.png";

import JwellsProduct1 from "../../Images/PRODUCTS_IMG/JWELLERY/PROD_JW1.png";
import JwellsProduct2 from "../../Images/PRODUCTS_IMG/JWELLERY/PROD_JW2.png";

import AssetProduct1 from "../../Images/PRODUCTS_IMG/ASSETMANAGEMENT/PROD_ASS1.png";
import AssetProduct2 from "../../Images/PRODUCTS_IMG/ASSETMANAGEMENT/PROD_ASS2.png";

export default function Servicesection() {
  return (
    <>
      <section className="services-section" style={fullstylecss}>
        {/* first card image */}
        <div className="mainfull-specialisatoin container text-center  ">
          <div className="container text-center common-title ">
            <div className="row our-services">
              <div className="servicetag col container text-center md-12 lg-12 sm-12">
                <h2 className="common-heading align-content-center">
                  SPECIALIZATION's
                </h2>
              </div>
            </div>
          </div>

          <div className="card-one row g-2 ">
            <div
              className="col col-lg-4 col-md-12 col-sm-1 "
              data-aos="fade-in"
              data-aos-duration="3000"
            >
              <div className="text-center card-box rounded-2 ">
                <Link to={"/websitedesign"}>
                  <img
                    src={soft_dev_pic_ourspecialisation}
                    alt=""
                    className="cardbox-image"
                  />
                </Link>
                <h3 className="my-3">
                  <ReactTyped
                    strings={[
                      "Software Development",
                      "Website Designig",
                      "Buisness Solution's",
                    ]}
                    typeSpeed={100}
                    backSpeed={50}
                    cursorChar="|"
                    showCursor="false"
                    loop
                  />
                </h3>
                <p className="mb-5 header-paragraph-content">
                  {" "}
                  A personalised software's websites that will full-fill all
                  your needs.
                </p>
              </div>
            </div>
            {/* {showPopup && <Popupspecialisation />} */}

            {/* {Second card image} */}
            <div
              className="col col-lg-4 col-md-12 col-sm-1 "
              data-aos="fade-out"
              data-aos-duration="2000"
            >
              <div
                className="text-center card-box rounded-2 "
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                <img
                  src={servilancecam_our_specialisation}
                  alt=""
                  className="cardbox-image"
                />
                <h3 className="my-3">
                  <ReactTyped
                    strings={["Surveillance Camera's", "Biometric Scan"]}
                    typeSpeed={100}
                    backSpeed={50}
                    cursorChar="|"
                    showCursor="false"
                    loop
                  />
                </h3>
                <p className="mb-5 header-paragraph-content">
                  {" "}
                  Installations and maintainence at your Doorstep.
                </p>
              </div>
            </div>

            {/* Third card image*/}

            <div
              className="col col-lg-4 col-md-12 col-sm-1 "
              data-aos="fade-out"
              data-aos-duration="2000"
            >
              <div className="text-center card-box rounded-2 ">
                <img src={card3Image} alt="" className="cardbox-image" />
                <h3 className="my-3 ">
                  <ReactTyped
                    strings={["PC", "Laptop", "Desktop", "Printer"]}
                    typeSpeed={100}
                    backSpeed={100}
                    cursorChar=""
                    showCursor="true"
                    loop
                  />{" "}
                  Repair's
                </h3>
                <p className="mb-2 header-paragraph-content">
                  Printer, Desktops, Laptops all these repairs at your Door
                  Step.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container text-center" >

        <div className="container text-center">
            <h1 className='blink' style={{marginBottom:10+'vh'}}>Our New Product's</h1>
          </div>

          <div
            id="carouselExampleSlidesOnly"
            class="carousel slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <a href="/websitedesign"><img src={AdvProduct1} class="d-block w-100" alt="advocates diary" />
                </a>
              </div>
              <div class="carousel-item">
              <a href="/websitedesign"><img src={JwellsProduct2} class="d-block w-100" alt="jwellers erp" /></a>
              
              </div>
              <div class="carousel-item">
              <a href="/websitedesign"><img src={JwellsProduct1} class="d-block w-100" alt="jwellers erp" /></a>
              
              </div>
              <div class="carousel-item">
              <a href="/websitedesign"><img src={AssetProduct1} class="d-block w-100" alt="Asset Manager" /></a>
              
              </div>
              <div class="carousel-item">
              <a href="/websitedesign"><img src={AssetProduct2} class="d-block w-100" alt="Asset Manager" /></a>
              
              </div>
            </div>
          </div>

          
        </div>
      </section>

      {/* {OUR WORK SECTION BELOW HERE} */}

      <section className="productlistingsection">
        <div className="container text-center title-ourlistings">
          <div className="row our-services">
            <div className="servicetag col container md-12 lg-6 sm-6">
              <h1 className="common-heading-ourwork">Our Work's</h1>
            </div>
          </div>
        </div>

        <div className="container text-center ourservices-card-all  g-4">
          <div className="row row-cols-1 row-cols-md-2 g-4 ">
            <div className="col-12 col-lg-6 col-sm-2 col-md-6">
              <div className="cardproductservices card">
                <div className="row row-cols-2 row-cols-md-2 row-cols-sm-1 d-flex align-items-center ">
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12 ">
                    <img
                      src="https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExdmVsYnk3enVtY3RseHo4bWg0bmQ2czE1aG5rM210YTBpaGN4cTgxaSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/qgQUggAC3Pfv687qPC/giphy.gif"
                      className="card-img-top productlisting"
                      alt="..."
                    />
                  </div>
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12 ">
                    <div className="card-body ">
                      <h5 className="card-title cardheader-title">
                        Personalised Software's
                      </h5>
                      <p className="card-text" style={{ fontSize: 13 + "px" }}>
                        Changing your <b>Idea</b> and <b>Vision</b> into reality
                        increase your productivity with us.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col col-lg-6 col-sm-2 col-md-6 ">
              <div className="cardproductservices card ">
                <div className="row row-cols-2 row-cols-md-2 row-cols-sm-1 d-flex align-items-center">
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <img
                      src={camimg}
                      className="card-img-top productlisting"
                      alt="..."
                    />
                  </div>
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <div className="card-body">
                      <h5 className="card-title cardheader-title">
                        Survilleance Camera's
                      </h5>
                      <p className="card-text" style={{ fontSize: 13 + "px" }}>
                        Looking for installing Cameras at your <b>Office</b> ,
                        <b>Home</b> or any other <b>place</b> u are at right
                        place.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col col-lg-6 col-sm-2 col-md-6">
              <div className="cardproductservices card ">
                <div className="row row-cols-2 row-cols-md-2 row-cols-sm-1 d-flex align-items-center">
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <img
                      src={comserimg}
                      className="card-img-top productlisting-doorsteprepair"
                      alt="..."
                    />
                  </div>
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <div className="card-body">
                      <h5 className="card-title cardheader-title">
                        Doorstep Repairing
                      </h5>
                      <p className="card-text" style={{ fontSize: 13 + "px" }}>
                        Repair your <b>Pc's</b> ,<b>Laptops</b>, <b>Desktops</b>{" "}
                        at your door step at your place.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col col-lg-6 col-sm-2 col-md-6">
              <div className="cardproductservices card ">
                <div className="row row-cols-2 row-cols-md-2 row-cols-sm-1 d-flex align-items-center">
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <img
                      src="https://i.gifer.com/ISSh.gif"
                      className="card-img-top productlisting"
                      alt="..."
                    />
                  </div>
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <div className="card-body">
                      <h5 className="card-title cardheader-title">
                        Printer Repairs
                      </h5>
                      <p className="card-text" style={{ fontSize: 13 + "px" }}>
                        Stuck with the <b>Broken</b> printer or Out of{" "}
                        <b>Ink</b> get repaired at your Door step.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col col-lg-6 col-sm-2 col-md-6">
              <div className="cardproductservices card ">
                <div className="row row-cols-2 row-cols-md-2 row-cols-sm-1 d-flex align-items-center">
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <img
                      src="https://media3.giphy.com/media/9igGG6KxpY0eY0Sr5u/giphy.gif"
                      className="card-img-top productlisting"
                      alt="..."
                    />
                  </div>
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <div className="card-body">
                      <h5 className="card-title cardheader-title">
                        Servers-Installation's
                      </h5>
                      <p className="card-text" style={{ fontSize: 13 + "px" }}>
                        Installation of the <b>Servers</b> and manage your
                        office or workplace <b>Servers</b> at only{" "}
                        <b>One Call</b>.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col col-lg-6 col-sm-2 col-md-6">
              <div className="cardproductservices card ">
                <div className="row row-cols-2 row-cols-md-2 row-cols-sm-1 d-flex align-items-center">
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <img
                      src={networking_our_specialisation}
                      className="card-img-top productlisting"
                      alt="..."
                    />
                  </div>
                  <div className="col-12 col-lg-6 col-sm-12 col-md-12">
                    <div className="card-body">
                      <h5 className="card-title cardheader-title">
                        Networking-Cabeling
                      </h5>
                      <p className="card-text" style={{ fontSize: 13 + "px" }}>
                        Wanted to install the wifi on diffrent floors of your{" "}
                        <b>Home</b>,<b>Hotel</b>,<b>Pg's</b> and more{" "}
                        <b>Call Now</b>.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
